/** @format */
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import {
    SortBySelect,
    SortBySelectProps,
} from '@toucan/client/features/search/components/sort-by-select';

import { DEFAULT_TEST_ID } from './constants';
import { styles } from './control-group.styles';

export type ControlGroupProps = SortBySelectProps & {
    'data-testid'?: string;
    className?: string;
    children?: ReactNode;
};

export const StyledControlGroup = styled.div`
    ${styles}
`;

export const ControlGroup: FunctionComponent<ControlGroupProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    children,
    options,
    selectedOption,
    onSortByChange,
    ...otherProps
}: ControlGroupProps) => {
    return (
        <StyledControlGroup data-testid={dataTestId} {...otherProps}>
            <SortBySelect
                data-testid={`${dataTestId}__sort-by-select`}
                className="control-group-item"
                options={options}
                selectedOption={selectedOption}
                onSortByChange={onSortByChange}
            />
        </StyledControlGroup>
    );
};
